/*
  Light click animation for hero call-to-action links marked [data-feld-burst]
  (sections/season-hero.liquid): the button presses in, a sheen sweeps across it and a
  ring of ember sparks scatters from the click point, then the link opens. Transform and
  opacity only. Modified clicks (new tab etc.) and reduced-motion users get the plain link.
*/
(() => {
  const SPARKS = 14;
  const NAVIGATE_AFTER_MS = 520;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const burst = (x, y) => {
    const layer = document.createElement('div');
    layer.className = 'feld-burst';
    layer.style.left = `${x}px`;
    layer.style.top = `${y}px`;
    layer.setAttribute('aria-hidden', 'true');

    const ring = document.createElement('span');
    ring.className = 'feld-burst__ring';
    layer.appendChild(ring);

    for (let i = 0; i < SPARKS; i++) {
      const spark = document.createElement('span');
      spark.className = i % 3 === 0 ? 'feld-burst__spark feld-burst__spark--star' : 'feld-burst__spark';
      const angle = (360 / SPARKS) * i + (Math.random() * 16 - 8);
      const distance = 46 + Math.random() * 46;
      spark.style.setProperty('--angle', `${angle}deg`);
      spark.style.setProperty('--distance', `${distance}px`);
      spark.style.setProperty('--delay', `${Math.round(Math.random() * 60)}ms`);
      layer.appendChild(spark);
    }

    document.body.appendChild(layer);
    setTimeout(() => layer.remove(), 1000);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-feld-burst][href]');
    if (!link || link.classList.contains('is-bursting')) return;
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;
    if (reducedMotion.matches) return;

    event.preventDefault();
    const rect = link.getBoundingClientRect();
    const x = event.clientX || rect.left + rect.width / 2;
    const y = event.clientY || rect.top + rect.height / 2;

    link.classList.add('is-bursting');
    burst(x, y);
    setTimeout(() => {
      window.location.href = link.href;
    }, NAVIGATE_AFTER_MS);
  });

  // Coming back with the browser's back button restores the page from cache
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('a[data-feld-burst].is-bursting').forEach((link) => link.classList.remove('is-bursting'));
  });
})();
